import { SvgIcon, SvgIconProps } from "@mui/material";

export function MotorcycleIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M17.42,10 L13.41,6 L9,6 L9,8 L12.59,8 L14.59,10 L6.5,10 C4,10 2,12 2,14.5 C2,17 4,19 6.5,19 C8.72,19 10.56,17.38 10.92,15.27 L13.04,14 C13,14.17 13,14.33 13,14.5 C13,17 15,19 17.5,19 C20,19 22,17 22,14.5 C22,12 20,10 17.5,10 M8.84,15.26 C8.5,16.27 7.58,17 6.47,17 C5.09,17 3.97,15.88 3.97,14.5 C3.97,13.12 5.09,12 6.47,12 C7.59,12 8.5,12.74 8.84,13.75 L6,13.75 L6,15.25 L8.84,15.26 M17.47,17 C16.09,17 14.97,15.88 14.97,14.5 C14.97,13.12 16.09,12 17.47,12 C18.8507119,12 19.97,13.1192881 19.97,14.5 C19.97,15.8807119 18.8507119,17 17.47,17 Z" />
    </SvgIcon>
  );
}
